<template>
  <div>
    <ejs-datetimepicker
      :placeholder='data.placeholder'
      :enabled='data.enabled'
      :name='data.name'
      :allowEdit='false'
      :locale='locale'
      :min='minDate'
      step='1'
      :format='data.dataFormat'
      timeFormat='HH:mm:ss'
      v-model='data.value'>
    </ejs-datetimepicker>
  </div>
</template>

<script>
export default {
  name: 'FormTime',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    defaultData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      minDate: ''
    };
  },
  beforeMount() {
    this.minDate = JSON.stringify(this.defaultData) !== '{}' ? '' : new Date();
    if (this.minDate && this.data.name === 'startTime') {
      this.data.value = this.minDate;
    }
    if (this.minDate && this.data.name === 'endTime') {
      this.data.value = this.minDate.getTime() + 24 * 60 * 60 * 1000;
    }
    this.data.value = (JSON.stringify(this.defaultData) !== '{}' && this.defaultData[this.data.name]) ? this.defaultData[this.data.name] : this.data.value;
    if (this.data.value) {
      this.data.value = new Date(this.data.value).Format(this.data.dataFormat);
    }
    this.data.enabled = JSON.stringify(this.defaultData) !== '{}' ? false : this.data.enabled;
  }
};
</script>
